module.exports = __webpack_public_path__ + "media/images/icon_h1_interact-a80a0490df72fa3e59b4e241cdede2ee.png";